export interface TimelineMilestone {
	year: string
	title: string
	description: string
	tags: string[]
}

export const careerTimelineContent = {
	title: 'Career Timeline',
	description: 'Two decades in tech — from network cables to cloud-native M365 architecture and AI-assisted development',

	milestones: [
		{
			year: '2001',
			title: 'Systems & Network Engineering',
			description: 'Started in IT infrastructure — networks, servers, protocols and troubleshooting. The foundation that still pays off daily when developing and debugging anything between browser and backend.',
			tags: ['Networking', 'BSD / Linux / Windows Servers', 'Troubleshooting']
		},
		{
			year: '2008',
			title: '.NET Development',
			description: 'Automating infrastructure & writing tools for myself and colleagues started my shift to software development.',
			tags: ['C#', '.NET', 'REST', 'SOAP']
		},
		{
			year: '2009',
			title: 'SharePoint & Automation',
			description: 'Enterprise SharePoint development, integration and administration. PowerShell and later PnP provisioning, automating everything repetitive.',
			tags: ['SharePoint', 'PowerShell', 'PnP']
		},
		{
			year: '2017',
			title: 'Agile Teams',
			description: 'Scrum and Kanban became the daily rhythm — iterative delivery, retrospectives, continuous improvement.',
			tags: ['Scrum', 'Kanban', 'JIRA']
		},
		{
			year: '2019',
			title: 'SPFx & Modern Frontend',
			description: 'SharePoint Framework with React and TypeScript — modern web parts and extensions shipped through CI/CD pipelines.',
			tags: ['SPFx', 'React', 'TypeScript', 'CI/CD']
		},
		{
			year: '2020',
			title: 'Remote by Choice',
			description: 'Mostly remote since 2017, the pandemic only confirmed what I already knew: my best work happens in a quiet home office surrounded by nature, with the freedom to structure the day around deep focus. I never went back, and I won\'t — no office, no hybrid. I work with clients who lead with trust and measure results, not hours in a chair; a company that can\'t trust this isn\'t one I want to work with. The technology has been ready for years, and the planet needs less commute, not more.',
			tags: ['Remote-only', 'No hybrid', 'Deep work', 'Results over presence']
		},
		{
			year: '2021',
			title: 'Azure & Teams Platform',
			description: 'Serverless integrations with Azure Functions, Microsoft Graph and Entra ID. Custom Teams apps. Infrastructure as code with Terraform.',
			tags: ['Azure Functions', 'MS Graph', 'Teams apps', 'Terraform']
		},
		{
			year: '2024',
			title: 'Cloud-Native & GitOps',
			description: 'Kubernetes on AKS, multi-cluster management with Rancher, GitOps continuous delivery with Argo CD.',
			tags: ['Kubernetes', 'AKS', 'Rancher', 'Argo CD']
		},
		{
			year: '2024–25',
			title: 'AI-Assisted Development',
			description: 'Two professional AI development courses. Understanding LLM architecture, reinforcement learning, cognitive services. Running and instructing coding agents. Applying AI where it genuinely adds value — refactoring, design, simplification, removal of boring routines.',
			tags: ['AI agents', 'LLM architecture', 'Prompting', 'RAG']
		}
	] as TimelineMilestone[]
}
